module.exports = __webpack_public_path__ + "pa.svg?d807798eaca3f549b82fcb1f9f14e8e5";